import React, {useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {MoneyBackMini, Question, Icon} from '@optimaxdev/icons';
import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {Price} from 'components/price/price';
import {CART_BUTTON} from 'constants/analytics/events/cart';
import {CHECKOUT_ARBITRARY} from 'constants/analytics/events/checkout';
import {PDP_CL} from 'constants/analytics/events/pdp';

import {RebatePopup} from '../rebatePopup/rebatePopup';

import s from './rebateOffer.scss';

const REBATE_ANALYTICS_EVENTS: Record<
    | 'pdpTopSectionCta'
    | 'pdpWizardQuantity'
    | 'pdpWizardSummaryCta'
    | 'cartItem'
    | 'cartFooter'
    | 'checkoutReview',
    Parameters<typeof sendDesktopAnalyticsEvent>
> = {
    cartFooter: [
        CART_BUTTON,
        {
            action: 'Right Section',
            label: 'Qualify For A Rebate Info',
        },
    ],
    cartItem: [
        CART_BUTTON,
        {
            action: 'CL Rebate',
            label: 'Qualify For A Rebate Info',
        },
    ],
    checkoutReview: [
        CHECKOUT_ARBITRARY,
        {
            action: 'Side Bar',
            label: 'Qualify For A Rebate Info',
        },
    ],
    pdpTopSectionCta: [
        PDP_CL,
        {
            action: 'Product Details',
            label: 'Qualify For A Rebate Info',
        },
    ],
    pdpWizardQuantity: [
        PDP_CL,
        {
            action: 'Wizard - Choose quantity',
            label: 'Qualify For A Rebate Info',
        },
    ],
    pdpWizardSummaryCta: [
        PDP_CL,
        {
            action: 'Wizard - Summary',
            label: 'Qualify For A Rebate Info',
        },
    ],
};

type PropsType = {
    className?: string;
    total?: number | null;
    isPla?: boolean;
    eventName: keyof typeof REBATE_ANALYTICS_EVENTS;
    children?: React.ReactNode;
    cartNewUI?: boolean;
};
/**
 * renders rebate offer
 *  @returns {React.ReactElement} - Rebate offer
 */
export const RebateOffer: React.FC<PropsType> = ({
    children,
    className = '',
    eventName,
    isPla = false,
    total,
}) => {
    const isClRebate = useFeature('clRebate') && !isPla;
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenPopup = () => {
        setIsModalOpen(true);
        sendDesktopAnalyticsEvent(...REBATE_ANALYTICS_EVENTS[eventName]);
    };

    if (!children || !isClRebate) return null;

    return (
        <>
            <div
                className={classNames(s.rebate, {
                    [className]: className,
                })}
            >
                {!total && <Icon className={s.rebateIcon} icon={MoneyBackMini} label="Rebate" />}
                <span
                    className={classNames(s.rebateText, {
                        [s.rebateTextTotal]: total,
                    })}
                >
                    {children}
                </span>
                <button className={s.questionMark} onClick={handleOpenPopup} type="button">
                    <Icon icon={Question} label="Help" />
                </button>
                {total && (
                    <span className={s.total}>
                        <Price>{total}</Price>
                    </span>
                )}
            </div>
            <RebatePopup isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};
